// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.loading-text {
  position: absolute;
  top: 95vh;
  left: 10px;
  color: white;
  font-size: 20px;
  font-weight: bold;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.dot1 {
  animation: blink 1s infinite;
}

.dot2 {
  animation: blink 1s infinite 0.2s;
}

.dot3 {
  animation: blink 1s infinite 0.4s;
}

.dot4 {
  animation: blink 1s infinite 0.5s;
}

/* novo loading  */
.loading-text-change {
  color: white;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  text-align: center;
  z-index: 2;
}

.background-container {
  position: relative;
  width: 100%;
  height: 100vh;
  /* Altura total da tela */
  overflow: hidden;
  display: contents;
}

.background-white {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  z-index: 1;
}

.background-blue {
  position: absolute;
  bottom: 0;
  /* Altera para bottom para crescer de baixo para cima */
  left: 0;
  width: 100%;
  height: 0;
  z-index: 2;
  transition: height 0.5s ease;
  /* Transição suave para altura */
}

.loading-sucess {
  border: 4px white solid;
  width: 128px;
  height: 128px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
}

.texto-descricao-carregamento {
  display: flex;
  flex-direction: row;
}

@keyframes scale-down {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}
.fade-out-animation {
  animation-duration: var(--ids_motion_time_superslow_03);
  animation-timing-function: var(--ids_motion_easing_effective_decelerate_standard);
  animation-name: fade-out;
}

.fade-in-animation {
  animation-duration: var(--ids_motion_time_superslow_03);
  animation-timing-function: var(--ids_motion_easing_effective_decelerate_standard);
  animation-name: fade-in;
}

.text-animation-left {
  animation: slideLeft 1s forwards;
  animation-delay: calc(var(--char-index) * 0.01s);
}

@keyframes slideLeft {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  99% {
    transform: translateX(-8%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
.text-animation-rigth {
  animation: slideRigth 1s forwards;
  animation-delay: calc(var(--char-index) * 0.01s);
}

@keyframes slideRigth {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  99% {
    transform: translateX(8%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
.progress-circle {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

circle {
  transition: stroke-dashoffset 0.5s ease-in-out;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/loading-circulo/loading-circulo/loading-circulo.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAEF;;AACA;EACE;IACE,UAAA;EAEF;EACA;IACE,UAAA;EACF;EAEA;IACE,UAAA;EAAF;AACF;AAGA;EACE,4BAAA;AADF;;AAIA;EACE,iCAAA;AADF;;AAIA;EACE,iCAAA;AADF;;AAIA;EACE,iCAAA;AADF;;AAIA,kBAAA;AAEA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AAFF;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;AAFF;;AAKA;EACE,kBAAA;EACA,SAAA;EACA,uDAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,4BAAA;EACA,gCAAA;AAFF;;AAKA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;AAFF;;AAKA;EACE;IACE,mBAAA;IACA,UAAA;EAFF;EAKA;IACE,mBAAA;IACA,UAAA;EAHF;AACF;AAMA;EACE,uDAAA;EACA,iFAAA;EACA,wBAAA;AAJF;;AAOA;EACE,uDAAA;EACA,iFAAA;EACA,uBAAA;AAJF;;AAQA;EACE,gCAAA;EACA,gDAAA;AALF;;AAQA;EACE;IACE,wBAAA;IACA,UAAA;EALF;EAQA;IACE,0BAAA;IACA,UAAA;EANF;EASA;IACE,wBAAA;IACA,UAAA;EAPF;AACF;AAUA;EACE,iCAAA;EACA,gDAAA;AARF;;AAWA;EACE;IACE,wBAAA;IACA,UAAA;EARF;EAWA;IACE,yBAAA;IACA,UAAA;EATF;EAYA;IACE,wBAAA;IACA,UAAA;EAVF;AACF;AAaA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAXF;;AAcA;EACE,8CAAA;EACA,yBAAA;EACA,yBAAA;AAXF","sourcesContent":[".loading-text {\n  position: absolute;\n  top: 95vh;\n  left: 10px;\n  color: white;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.dot1 {\n  animation: blink 1s infinite;\n}\n\n.dot2 {\n  animation: blink 1s infinite 0.2s;\n}\n\n.dot3 {\n  animation: blink 1s infinite 0.4s;\n}\n\n.dot4 {\n  animation: blink 1s infinite 0.5s;\n}\n\n/* novo loading  */\n\n.loading-text-change {\n  color: white;\n  font-size: 20px;\n  font-weight: bold;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  bottom: 0;\n  text-align: center;\n  z-index: 2;\n}\n\n.background-container {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  /* Altura total da tela */\n  overflow: hidden;\n  display: contents;\n}\n\n.background-white {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #FFFFFF;\n  z-index: 1;\n}\n\n.background-blue {\n  position: absolute;\n  bottom: 0;\n  /* Altera para bottom para crescer de baixo para cima */\n  left: 0;\n  width: 100%;\n  height: 0;\n  z-index: 2;\n  transition: height 0.5s ease;\n  /* Transição suave para altura */\n}\n\n.loading-sucess {\n  border: 4px white solid;\n  width: 128px;\n  height: 128px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100px;\n}\n\n.texto-descricao-carregamento {\n  display: flex;\n  flex-direction: row;\n}\n\n@keyframes scale-down {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(0);\n    opacity: 0;\n  }\n}\n\n.fade-out-animation {\n  animation-duration: var(--ids_motion_time_superslow_03);\n  animation-timing-function: var(--ids_motion_easing_effective_decelerate_standard);\n  animation-name: fade-out;\n}\n\n.fade-in-animation {\n  animation-duration: var(--ids_motion_time_superslow_03);\n  animation-timing-function: var(--ids_motion_easing_effective_decelerate_standard);\n  animation-name: fade-in;\n}\n\n\n.text-animation-left {\n  animation: slideLeft 1s forwards;\n  animation-delay: calc(var(--char-index) * 0.01s);\n}\n\n@keyframes slideLeft {\n  0% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n\n  99% {\n    transform: translateX(-8%);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.text-animation-rigth {\n  animation: slideRigth 1s forwards;\n  animation-delay: calc(var(--char-index) * 0.01s);\n}\n\n@keyframes slideRigth {\n  0% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n\n  99% {\n    transform: translateX(8%);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.progress-circle {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\ncircle {\n  transition: stroke-dashoffset 0.5s ease-in-out;\n  transform: rotate(-90deg);\n  transform-origin: 50% 50%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
